<template>
<div class="MHome">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div class="loading" v-show="loading">
        <van-loading vertical type="spinner" color="#1989fa"><span style="font-size: 0.24rem">加载中...</span>
        </van-loading>
    </div>
    <AllSilderH5 ref="allSilderH5" v-show="$route.name !== 'MLogin' && $route.name !== 'MRegister' && $route.name !== 'MResetPwd'"></AllSilderH5>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {wxLogin} from 'common/js/mixin'
export default {
    name: 'MRHome',
    mixins: [wxLogin],
    data() {
        return {
        }
    },
    created() {
        if (this.ClientType === 1) {
            this.setClientType(2)
        }
    },
    mounted() {},
    methods: {
        ...mapActions(['setClientType'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'loading', 'ClientType', 'domainlist'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/index";
.MHome {
    min-height: 100vh;
    font-size: 0.24rem;
    width: 100%;
    background: $c-global;
    // background:rgba(245,247,250,1);
    input {
        -webkit-appearance: none;
        border: none;
        outline: none;
    }
    .loading {
        @include flexBox(center);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .2);
        z-index: 10000;
    }
    img[lazy='loading'], img[lazy=error] {
        width: 0.64rem !important;
        height: 0.64rem !important;
    }
}
</style>